import {
  Card,
  CardBody,
  CardHeader,
  Col,
  FormGroup,
  Label,
  Row,
  Table,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Tooltip,
  Badge,
  UncontrolledCollapse,
  Button,
} from "reactstrap";
import React, { Fragment, useState, useEffect } from "react";
import * as SweetAlert from "sweetalert2";
import { Link, useHistory } from "react-router-dom";
import { 
  downloadOrderInvoice, downloadOrderPresentmentInvoice, downloadCostPriceOrderInvoice, downloadOrderPdf,
  unSetTrackingData, openOrderCancelDialog, downloadCreditNote, downloadVGBarcodePDF
} from "../../store/orderSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { currencyFormatter, formatAsPrice, numericValue } from "../../../../utils/common";
import { FrasersReminders } from "./frasersReminders";

export const Item = (props) => {
  const { orderState, orderId, retrieveTrackingDetails, authData, onSendEmail, sellerPush, pushingSellerId, onPushSeller } = props;

  const dispatch = useDispatch();
  const history = useHistory();
  const currentUser = useSelector(({ authReducer }) => authReducer.data.user);
  const userState = useSelector(({ authReducer }) => authReducer.data);

  // GOD-TK-128: one line per brand seller that still has open items not on their store; nothing when there is nothing to push
  const renderSellerSyncLines = () => {
    const lines = Object.values(sellerPush || {}).filter((s) => s.status === "pushable" || s.status === "has_errors");
    if (!lines.length) return null;
    const isSeller = userState.user.role.name === "Seller";
    return (
      <div className="mb-2">
        {lines.map((s) => {
          const storeName = isSeller ? "your store" : `${s.seller_name || `Seller ${s.seller_id}`}'s store`;
          const count = (s.line_item_ids || []).length;
          const pushing = pushingSellerId === s.seller_id;
          return (
            <div
              key={s.seller_id}
              className="d-flex align-items-center justify-content-between mb-2"
              style={{ background: "#fdf2f2", border: "1px solid #f1b0b7", borderRadius: 6, color: "#b02a37", padding: "8px 14px", fontSize: 13 }}
            >
              <span>
                <i className="fa fa-exclamation-circle mr-2" aria-hidden="true"></i>
                {s.status === "has_errors"
                  ? `${storeName} rejected this order: ${(s.errors || []).map((e) => e.message).join(", ")}`
                  : `${count} ${count === 1 ? "item" : "items"} not yet on ${storeName}`}
              </span>
              <button
                type="button"
                disabled={pushing}
                onClick={() => onPushSeller(s.seller_id)}
                style={{ background: "#fff", border: "1px solid #dc3545", color: "#dc3545", borderRadius: 4, padding: "4px 14px", fontSize: 12, fontWeight: 500, cursor: pushing ? "default" : "pointer", opacity: pushing ? 0.6 : 1, whiteSpace: "nowrap" }}
              >
                {pushing ? "Syncing..." : s.status === "has_errors" ? "Retry sync" : `Sync with ${isSeller ? "my" : s.seller_name || "brand"} store`}
              </button>
            </div>
          );
        })}
      </div>
    );
  };
  const [invoiceLoadingIcon, setInvoiceLoadingIcon] = useState(false);
  const [presentmentInvoiceLoadingIcon, setPresentmentInvoiceLoadingIcon] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [costInvoiceLoading, setCostInvoiceLoading] = useState(false);
  const [creditNoteLoadingIcon, setCreditNoteLoadingIcon] = useState(false);
  const [isCancelVisible, setIsCancelVisible] = useState(false)
  
  // Enable "Notify Out of Stock" when any items are selected
  const hasSelectedItems = selectedItems.length > 0;
  let orderSubTotal = 0;
  let shippingDiscount = 0;
  const [discountsTotal, setDiscountsTotal] = useState({});
  let quantityTotal = 0;
  let vat = 0;
  let refundTotal = 0;
  //let discountsTotal = {};

  useEffect(() => {
    if (orderState && orderState.list && orderState.list.length > 0) {
      const isAllStatusUnfulfilled = orderState.list.every(item => item.status_id === 1);
        setIsCancelVisible(isAllStatusUnfulfilled);
    }

  },[orderState])

  const processPDFDownload = (name) => {
    const data = {
      id: orderId,
      params: {
        name: name,
        seller: authData.defaultSeller?.value,
      },
    };
    dispatch(downloadOrderPdf(data)).then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.payload]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${orderState.data ? orderState.data.order_name : "-"}_${name.replace(/\s+/g, "-")}_${new Date().toJSON().slice(0, 10)}.pdf`
      ); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
  };
  const handlePackageSlipDownload = () => {
    processPDFDownload("Package Slip");
  };
  const handlePickingTicketDownload = () => {
    processPDFDownload("Picking Ticket");
  };
  
  const handleVGBarcodeDownload = () => {
    const data = {
      order_ids: [orderId],
      type: "single",
    };
    dispatch(downloadVGBarcodePDF(data)).then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.payload]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `Vogacloset_Barcode_${orderState.data ? orderState.data.order_name : "-"}_${new Date().toJSON().slice(0, 10)}.pdf`
      ); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
  };

  const handleInvoiceDownload = () => {
    if (invoiceLoadingIcon) return;
    setInvoiceLoadingIcon(true);
    const data = {
      id: orderId,
      params: {
        seller: authData.defaultSeller?.value,
      },
    };
    dispatch(downloadOrderInvoice(data)).then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.payload]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${orderState.data ? orderState.data.order_name : "-"}_Invoice_${new Date().toJSON().slice(0, 10)}.pdf`); //or any other extension
      document.body.appendChild(link);
      link.click();
      setInvoiceLoadingIcon(false);
    });
  };

  const handlePresentmentInvoiceDownload = () => {
    if (invoiceLoadingIcon) return;
    setPresentmentInvoiceLoadingIcon(true);

    const data = {
      id: orderId,
      params: {
        seller: authData.defaultSeller?.value,
      },
    };

    dispatch(downloadOrderPresentmentInvoice(data))
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.payload]));
        const link = document.createElement("a");
        link.href = url;

        link.setAttribute(
          "download",
          `${orderState.data ? orderState.data.order_name : "-"}_PresentmentInvoice_${new Date()
            .toJSON()
            .slice(0, 10)}.pdf`
        );

        document.body.appendChild(link);
        link.click();
        setPresentmentInvoiceLoadingIcon(false);
      })
      .catch(() => setPresentmentInvoiceLoadingIcon(false));
  };


  const handleCostPriceInvoice = () => {
    if (costInvoiceLoading) return;
    setCostInvoiceLoading(true);

    const data = {
      id: orderId,
      params: {
        seller: authData.defaultSeller?.value,
        itemIds: selectedItems, // all selected row IDs
      },
    };

    // Replace with your actual API dispatch
    dispatch(downloadCostPriceOrderInvoice(data)).then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.payload]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${orderState.data ? orderState.data.order_name : "-"}_CostPriceInvoice_${new Date().toJSON().slice(0, 10)}.pdf`
      );
      document.body.appendChild(link);
      link.click();
      setCostInvoiceLoading(false);
    }).catch(() => {
      setCostInvoiceLoading(false);
    });
  };

  const noTracking = () => {
    dispatch(unSetTrackingData());
    toast.warning("Tracking details are required to be added to this item", {
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  const getDiscountDetails = (discount_allocations) => {
    let result = discount_allocations.map((allocation) => {
      let discount_application = orderState.data.discount_applications[allocation.discount_application_index];

      if (discount_application.target_selection === "entitled") {
        let value =
          discount_application.value_type === "percentage"
            ? `${parseFloat(discount_application.value).toFixed(1).replace(/\.0$/, "")}%`
            : `£${allocation.amount_set.shop_money.amount}`;
        let code = discount_application.code ? ` (${discount_application.code})` : ` (${discount_application.title})`;

        return value + code + " (-£" + allocation.amount + ")";
      }
      return null;
    });

    const resultWithBr = result.filter((item) => item !== null); // Filter out null values

    if (resultWithBr && resultWithBr.length > 0) {
      resultWithBr.map((item) => (
        <>
          {item}
          <br />
        </>
      ));
      return (
        <div className="row">
          <p>
            <strong>Discount: </strong>&nbsp;{resultWithBr}
          </p>
        </div>
      );
    } else {
      return null;
    }
  };

  const hasEntitledDiscount = (discount_allocations) => {
    return discount_allocations.some((allocation) => {
      let discount_application = orderState.data.discount_applications[allocation.discount_application_index];
      return discount_application.target_selection === "entitled";
    });
  };

  const sumDiscountAllocationAmountsCodeWise = () => {
    let updatedDiscountsTotal = {};
    if (orderState.list.length > 0) {
      orderState.list.forEach((item, index) => {
        if (item.discount_allocations && item.discount_allocations.length > 0) {
          item.discount_allocations.forEach((allocation) => {
            let discount_application = orderState.data.discount_applications[allocation.discount_application_index];
            if (discount_application.target_selection == "entitled") {
              let discount = allocation.amount / item.quantity;

              let code = discount_application.code ? discount_application.code : discount_application.title;

              updatedDiscountsTotal[code] = (updatedDiscountsTotal[code] || 0) + discount;
            }
          }, 0);
        }
      });
    }
    return updatedDiscountsTotal;
  };

  const sumDiscountAllocationAmounts = (item) => {
    if (item.discount_allocations === undefined) return 0;

    return item.discount_allocations.reduce((total, allocation) => {
      let discount_application = orderState.data.discount_applications[allocation.discount_application_index];
      if (discount_application.target_selection == "entitled") {
        let discount = allocation.amount / item.quantity;
        return total + discount;
      }
      return total;
    }, 0);
  };

  const getPrice = (item, type) => {
    let price = parseFloat(item.price);
    let total_price = parseFloat(item.total_price_numeric);
    let discount = parseFloat(sumDiscountAllocationAmounts(item));

    if (item.discount_allocations && hasEntitledDiscount(item.discount_allocations)) {
      if (type == "subtotal") {
        let totalPrice = price - discount;
        let formattedPrice = `£${totalPrice.toFixed(2)}`;
        formattedPrice = (
          <>
            <span style={{ textDecoration: "line-through" }}>£{price.toFixed(2)}</span> <span>{formattedPrice}</span>
          </>
        );
        return formattedPrice;
      } else {
        return `£${(total_price - discount * item.quantity).toFixed(2)}`;
      }
    } else {
      if (type == "subtotal") {
        return `£${price.toFixed(2)}`;
      } else {
        return `£${total_price.toFixed(2)}`;
      }
    }
  };

  function calculateShippingVAT(grossAmount, vatPercentage) {
    let vatExcluded = grossAmount / (1 + vatPercentage);
    let vatAmount = Math.round((grossAmount - vatExcluded) * 100) / 100;

    return vatAmount;
  }

  function handleReferenceOrder(refObj) {
    history.push(`/order/${refObj.reference_id}/view`);
  }

  function handleCheckExchangeOrder(excObj) {
    history.push(`/order/${excObj}/view`);
  }

  function getGrandTotal(quantityTotal, refundTotal) {
    let grantTotal =
      numericValue(orderState.data.total_price) -
      numericValue(orderState.data.shipping_charges) +
      parseFloat(quantityTotal * orderState.data.per_item_shipping);
    grantTotal = grantTotal - refundTotal;
    return formatAsPrice(grantTotal);
  }

  useEffect(() => {
    const updatedDiscountsTotal = sumDiscountAllocationAmountsCodeWise();
    setDiscountsTotal(updatedDiscountsTotal);
  }, [orderState]);

  const getDiscountItems = () => {
    let discountItems = [];

    if (orderState.data && orderState.data.total_discount && orderState.data.total_discount > 0 && orderState.data.discount_applications.length > 0) {
      orderState.data.discount_applications.forEach((discount) => {
        if (discount.target_selection === "all") {
          let discountAmount = 0;
          let value =
            discount.value_type === "percentage"
              ? `${parseFloat(discount.value).toFixed(1).replace(/\.0$/, "")}%`
              : `£${parseFloat(discount.value).toFixed(2)}`;

          if (discount.value_type == "percentage") {
            if (discount.target_type == "shipping_line") {
              if (userState.user.role.name == "Seller") {
                return null;
              }
              discountAmount = (parseFloat(orderState.data.shipping_charges) * parseFloat(discount.value)) / 100;
              discountAmount = parseFloat(discountAmount).toFixed(2);
              shippingDiscount += discountAmount;
            } else {
              discountAmount = (orderSubTotal * parseFloat(discount.value)) / 100;
              discountAmount = discountAmount.toFixed(2);
            }
          } else {
            discountAmount = parseFloat(discount.value).toFixed(2);
          }

          if (discountAmount > 0) {
            discountItems.push({
              title_1: discount.code ? discount.code + " (" + value + ")" : discount.title + " (" + value + ")",
              title_2: discount.target_type == "shipping_line" ? "Shipping Discount" : "Order level discount",
              discountAmount: discountAmount,
            });
          }
        } else if(discount.target_type == "shipping_line"){
          let discountAmount = 0;

          let value =
            discount.value_type === "percentage"
              ? `${parseFloat(discount.value).toFixed(1).replace(/\.0$/, "")}%`
              : `£${parseFloat(discount.value).toFixed(2)}`;

          if (userState.user.role.name == "Seller") {
                return null;
          }

          discountAmount = (parseFloat(orderState.data.shipping_charges) * parseFloat(discount.value)) / 100;
          discountAmount = parseFloat(discountAmount).toFixed(2);
          shippingDiscount += discountAmount;

          if (discountAmount > 0) {
            discountItems.push({
              title_1: discount.code ? discount.code + " (" + value + ")" : discount.title + " (" + value + ")",
              title_2: discount.target_type == "shipping_line" ? "Shipping Discount" : "Order level discount",
              discountAmount: discountAmount,
            });
          }

        } else {
          let discountCode = discount.code ? discount.code : discount.title;
          let discountValue = 0;
          if (discountsTotal.hasOwnProperty(discountCode)) {
            discountValue = discountsTotal[discountCode];
            discountValue = discountValue.toFixed(2);
          }

          if (discountValue > 0) {
            discountItems.push({
              title_1: discountCode,
              title_2: "Order Item specific Discount",
              discountAmount: discountValue,
            });
          }
        }
      });
    }

    return discountItems;
  };

  const [tooltipOpen, setTooltipOpen] = useState({});

  // Toggle function to handle tooltip visibility
  const toggle = (id) => {
    setTooltipOpen((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const handleOrderCancel = (orderId) => {
    dispatch(openOrderCancelDialog(orderId));                              
  }

  const displayItemQty = (item) => {
    return (
      <>
        {item.quantity != item.actual_available_qty ? (
          <>
            <span className="font-weight-bold cursor-default" id={`TooltipItemAvaQty-${item.id}`}>
              {item.actual_available_qty}
            </span>
            <span className="px-2">/</span>
            <span
              className="font-weight-bold cursor-default"
              style={{ textDecoration: "line-through", textDecorationColor: "red" }}
              id={`TooltipItemQty-${item.id}`}
            >
              {item.quantity}
            </span>
          </>
        ) : (
          <>
            <span className="font-weight-bold cursor-default" id={`TooltipItemQty-${item.id}`}>
              {item.quantity}
            </span>
          </>
        )}

        {item.quantity != item.actual_available_qty && (
          <Tooltip
            isOpen={tooltipOpen[`avaqty_${item.id}`] || false}
            toggle={() => toggle(`avaqty_${item.id}`)}
            target={`TooltipItemAvaQty-${item.id}`}
          >
            Available Qty: {item.actual_available_qty}
          </Tooltip>
        )}

        <Tooltip isOpen={tooltipOpen[`qty_${item.id}`] || false} toggle={() => toggle(`qty_${item.id}`)} target={`TooltipItemQty-${item.id}`}>
          Ordered Qty: {item.quantity}
        </Tooltip>
      </>
    );
  };

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setSelectAll(isChecked);
    if (isChecked) {
      const allIds = orderState.list.map((item) => item.id);
      setSelectedItems(allIds);
    } else {
      setSelectedItems([]);
    }
  };

  const handleSelectItem = (id, isChecked) => {
    if (isChecked) {
      setSelectedItems((prev) => [...prev, id]);
    } else {
      setSelectedItems((prev) => prev.filter((itemId) => itemId !== id));
      setSelectAll(false);
    }
  };

  const handleCreditNoteDownload = () => {
      if (creditNoteLoadingIcon) return;
      setCreditNoteLoadingIcon(true);

      const data = {
        id: orderId,
        params: {
          seller: authData.defaultSeller?.value,
        },
      };

      dispatch(downloadCreditNote(data))
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.payload]));
          const link = document.createElement("a");
          link.href = url;

          link.setAttribute(
            "download",
            `${orderState.data ? orderState.data.order_name : "-"}_CreditNote_${new Date()
              .toJSON()
              .slice(0, 10)}.pdf`
          );

          document.body.appendChild(link);
          link.click();
          setCreditNoteLoadingIcon(false);
        })
        .catch(() => setCreditNoteLoadingIcon(false));
    };

   function handlePageDirection(item) {
    const status= item.return_status;
    const fulfillStatus= item.status;
    const returnStatusId= item.return_status_id;
    const isArchived = returnStatusId === 6;

    if (status === "Pending" || status === "Cancelled") {
      if(isArchived){
        return (
          <Link to={`${process.env.PUBLIC_URL}/order/pending-return-requests/${orderState.data.order_name}?isArchived=true`} style={{ textDecoration: "underline" }}>
            {status}
          </Link>
        );
      }else{
        return (
          <Link to={`${process.env.PUBLIC_URL}/order/pending-return-requests/${orderState.data.order_name}`} style={{ textDecoration: "underline" }}>
            {status}
          </Link>
        );
      }
      
    } else if (fulfillStatus === 'Unfulfilled' && status === "Cancellation requested") {
      return (
        <Link to={`${process.env.PUBLIC_URL}/order/pending-cancel/${orderState.data.order_name}`} style={{ textDecoration: "underline" }}>
          {status}
        </Link>
      );
    }else if (fulfillStatus === 'FulFilled' && status === "Under Admin Review") {
      return (
        <Link to={`${process.env.PUBLIC_URL}/order/return/${orderState.data.order_name}`} style={{ textDecoration: "underline" }}>
          {status}
        </Link>
      );
    } else {
      return <p>{status}</p>;
    }
  }  

  return (
    <Fragment>
      <Col sm="12">
        <Card className="ribbon-wrapper">
          <CardBody>
            <div className="ribbon ribbon-clip h5 ribbon-dark">Items from Order {orderState.data ? orderState.data.order_name : "-"}</div>
            {(orderState?.data || orderState?.reference_detail) &&
              <div className="position-absolute" style={{ top: "14px", right: "12px", fontWeight: 600, color: "#000000" }}>
                <div style={{display:'flex', alignItems :"center"}}>

                  {orderState?.data?.is_test_order === 1 && 
                    <div style={{marginRight : 15}}>
                      <Badge color='danger'>Test Order</Badge>
                    </div>
                 }
                 
                 {orderState?.reference_detail && 
                    <>
                      Reference{" "}
                      <button onClick={() => handleReferenceOrder(orderState?.reference_detail)} style={{ color: "#007bff", background: "transparent" }}>
                        {orderState?.reference_detail?.reference_order_name}
                      </button>{" "}
                  
                    </>
                  }
                 </div>
              </div>
            }
            {orderState.data &&
              orderState.data.risk_level !== "LOW" &&
              (orderState.data.fulfillment_status != "fulfilled" ? (
                <div className="text-danger">
                  <strong>Note:</strong> This order has been flagged as possibly fraudulent. Please do not process and contact customer service at{" "}
                  <a href="mailto:info@goddiva.co.uk">info@goddiva.co.uk </a> as soon as possible.
                </div>
              ) : null)}
            {orderState.data && orderState.data.note_attributes && (() => {
              const noteAttrs = orderState.data.note_attributes;
              const useRrp = noteAttrs.find(a => a.name === 'use_rrp')?.value === 'true';
              const priceChangeReason = noteAttrs.find(a => a.name === 'price_change_reason')?.value;
              const presentmentCurrency = orderState.data.presentment_currency;
              const showCurrency = presentmentCurrency && presentmentCurrency !== 'GBP';
              if (!useRrp && !priceChangeReason) return null;
              return (
                <div className="py-2 mb-2 alert alert-info fade show" role="alert" style={{fontSize: 13}}>
                  <i className="fa fa-info-circle mr-2"></i>
                  <strong>Order Notes:</strong>
                  <ul className="mb-0 mt-1" style={{paddingLeft: 20}}>
                    {useRrp && <li>This order was placed using full retail prices (RRP).</li>}
                    {/*showCurrency && <li>This order was placed in <strong>{presentmentCurrency}</strong> (presentment amount: {presentmentCurrency} {parseFloat(orderState.data.presentment_amount).toFixed(2)}).</li>*/}
                    {priceChangeReason && <li>Some item prices were manually adjusted. Reason: <strong>"{priceChangeReason}"</strong></li>}
                  </ul>
                </div>
              );
            })()}
            {renderSellerSyncLines()}
            <FrasersReminders orderState={orderState} orderId={orderId} />
            {orderState.data
              ? orderState.data.customer_name !== "-" && (
                  <div className="mt-2 d-flex justify-content-end">
                    {userState.user.role.name!=="Seller" && orderState.data.partner_id == 12 && orderState.can_show_credit_note && (
                        <div className="p-2">
                          <button
                            onClick={handleCreditNoteDownload}
                            className={creditNoteLoadingIcon ? "btn btn-danger btn-block disabled" : "btn btn-danger btn-block"}
                            >
                            {creditNoteLoadingIcon ? (
                              <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>
                            ) : (
                              `Credit Note (in ${orderState.data.presentment_currency})`
                            )}
                          </button>
                      </div>
                    )}

                    {selectedItems.length > 0 && (
                      <div className="p-2">
                        <button
                          onClick={handleCostPriceInvoice}
                          className={costInvoiceLoading ? "btn btn-info btn-block disabled" : "btn btn-info btn-block"}
                        >
                          {costInvoiceLoading ? (
                            <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>
                          ) : (
                            "Cost Price Invoice"
                          )}
                        </button>
                      </div>
                    )}
                    {selectedItems.length > 0 && (orderState?.list || []).some(item =>
                      selectedItems.includes(item.id)
                    ) && onSendEmail && (
                      <div className="p-2">
                        <button
                          onClick={() => onSendEmail(selectedItems)}
                          className="btn btn-primary btn-block"
                        >
                          Notify Out of Stock
                        </button>
                      </div>
                    )}
                    {userState.user.role.name!=="Seller" && orderState.data.presentment_currency != "GBP" && (
                        <div className="p-2">
                          <button
                            onClick={handlePresentmentInvoiceDownload}
                            className={presentmentInvoiceLoadingIcon ? "btn btn-info btn-block disabled" : "btn btn-info btn-block"}
                            >
                            {presentmentInvoiceLoadingIcon ? (
                              <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>
                            ) : (
                              `Invoice (in ${orderState.data.presentment_currency})`
                            )}
                          </button>
                      </div>
                    )}
                    
                    {(orderState.data.financial_status === "paid" && isCancelVisible) && <div className="p-2">
                      <button onClick={() =>handleOrderCancel(orderId)} className="btn btn-secondary btn-block">
                          Cancel
                      </button>
                    </div>}
                    <div className="p-2">
                      <button
                        onClick={handleInvoiceDownload}
                        className={invoiceLoadingIcon ? "btn btn-success btn-block disabled" : "btn btn-success btn-block"}
                      >
                        {invoiceLoadingIcon ? <i className="fa fa-spinner fa-spin" aria-hidden="true"></i> : "Invoice (in GBP)"}
                      </button>
                    </div>
                    <div className="p-2">
                      <Link className="btn btn-primary btn-block" to={`${process.env.PUBLIC_URL}/order/${orderId}/return-items`}>
                        Refund
                      </Link>
                    </div>
                    {currentUser.permission.includes("Create Packing Slips") && (
                      <div className="p-2">
                        <button onClick={handlePackageSlipDownload} className="btn btn-danger btn-block">
                          Packing Slip
                        </button>
                      </div>
                    )}
                    {/* Only showing for Vogacloset */}
                    {currentUser.permission.includes("Create Picking Ticket") && orderState.data.partner_id == 4 && (
                      <div className="p-2">
                        <button onClick={handleVGBarcodeDownload} className="btn btn-primary btn-block" title="Download Vogacloset Barcode">
                          VG Barcode
                        </button>
                      </div>
                    )}
                    {currentUser.permission.includes("Create Picking Ticket") && (
                      <div className="p-2">
                        <button onClick={handlePickingTicketDownload} className="btn btn-primary btn-block">
                          Picking Ticket
                        </button>
                      </div>
                    )}
                  </div>
                )
              : ""}

            {/* The header's seller filter (kept in localStorage across reloads) limits the items shown; without this an order with only other sellers' items looks empty with £0 totals */}
            {orderState.data && orderState.list.length === 0 && orderState.data.total_items > 0 && authData.defaultSeller?.value && (
              <div className="alert alert-warning py-2 mb-2" role="alert" style={{ fontSize: 13 }}>
                <i className="fa fa-filter mr-2"></i>
                This order has {orderState.data.total_items} item(s), but none belong to the seller selected in the header
                {authData.defaultSeller.label ? <> (<strong>{authData.defaultSeller.label}</strong>)</> : ""}. Clear the seller filter in the header to see the items and totals.
              </div>
            )}

            <div className="table-responsive">
              <Table>
                <thead className="thead-light">
                  <tr>
                    <th scope="col" style={{ whiteSpace: "nowrap", width: "5%", textAlign: "center" }}>
                      <input
                        type="checkbox"
                        checked={selectAll}
                        onChange={handleSelectAll}
                      />
                    </th>
                    <th scope="col" style={{ whiteSpace: "nowrap", width: "40%" }}>
                      Product
                    </th>
                    <th scope="col" style={{ whiteSpace: "nowrap", width: "15%" }}>
                      Status
                    </th>
                    <th scope="col" style={{ whiteSpace: "nowrap", width: "15%" }}>
                      Return Status
                    </th>
                    <th scope="col" style={{ whiteSpace: "nowrap", width: "10%", textAlign: "center" }}>
                      Quantity
                    </th>
                    <th scope="col" style={{ whiteSpace: "nowrap", width: "10%", textAlign: "right" }}>
                      Price
                    </th>
                    <th scope="col" style={{ whiteSpace: "nowrap", width: "10%", textAlign: "right" }}>
                      Total
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {orderState.list.length > 0
                    ? orderState.list.map((item, index) => {
                        let subTotal = getPrice(item);
                        let withoutCurrency = parseFloat(subTotal.replace(/[£]/g, "").replace(/,/g, ""));
                        orderSubTotal += withoutCurrency;
                        quantityTotal += item.quantity;
                        //vat += item.unit_tax * item.quantity;
                        vat += item.total_tax;
                        const exchangeOrder = orderState.exchange_order_details?.[item.line_item_id];
                        return (
                          <Fragment>
                            <tr key={"item_" + item.id}>
                              <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                <input
                                  type="checkbox"
                                  checked={selectedItems.includes(item.id)}
                                  onChange={(e) => handleSelectItem(item.id, e.target.checked)}
                                />
                              </td>
                              <td className="col-2">
                                <div className="row">
                                  <div className="col-md-2">
                                    <img width="40" className="img-fluid" src={item.image} />
                                  </div>
                                  <div className="col-md-9">
                                    <div className="row">
                                      <p
                                        className={"font-primary"}
                                        style={{
                                          marginBottom: 0,
                                          display: "inline-flex",
                                          alignItems: "center",
                                          gap: 6,
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        {item.sku}
                                        {item.is_outlet && (
                                          <span
                                            style={{
                                              color: "rgb(251, 44, 54)",
                                              borderRadius: 3,
                                              padding: "2px 6px",
                                              fontSize: "0.6rem",
                                              fontWeight: "bold",
                                              border: "1px solid rgb(251, 44, 54)",
                                              display: "inline-block",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            Outlet Item
                                          </span>
                                        )}
                                      </p>
                                    </div>
                                    <div className="row">
                                      {(() => {
                                        if (item.status_id === 1) {
                                          return (
                                            <i
                                              onClick={noTracking}
                                              style={{ margin: "auto", marginLeft: 0 }}
                                              className="fa fa-truck mr-1 text-primary"
                                            ></i>
                                          );
                                        } else if (item.status_id === 2) {
                                          return (
                                            <a
                                              onClick={() => {
                                                retrieveTrackingDetails(item.id);
                                              }}
                                            >
                                              <i className="fa fa-truck mr-1 text-success"></i>
                                            </a>
                                          );
                                        } else {
                                          return <i className="fa fa-truck mr-1 text-dark"></i>;
                                        }
                                      })()}
                                      {item.name}
                                    </div>
                                    <div className="row">
                                      <p>
                                        <strong>Brand: </strong>
                                        {item.brand}
                                      </p>
                                    </div>
                                    <div className="row">
                                      <p>
                                        <strong>Color: </strong>
                                        {item.colour}
                                      </p>
                                    </div>
                                    <div className="row">
                                      <p>
                                        <strong>Size: </strong>
                                        {item.size}
                                      </p>
                                    </div>
                                    {item.discount_allocations && item.discount_allocations.length > 0 && getDiscountDetails(item.discount_allocations)}
                                    {exchangeOrder && (
                                      <div className="row">
                                        <button
                                          style={{
                                            background: "transparent",
                                            fontWeight: 600,
                                            color: "#007bff",
                                            textAlign: "left",
                                            paddingLeft: "0px",
                                          }}
                                          onClick={() => handleCheckExchangeOrder(exchangeOrder.order_id)}
                                        >
                                          Exchange Order {exchangeOrder.order_name}
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div style={{ marginTop: "2rem" }}>{item.status}</div>
                              </td>
                              <td>
                                <div style={{ marginTop: "2rem" }}>{handlePageDirection(item)}</div>
                              </td>
                              <td>
                                <div style={{ marginTop: "2rem", textAlign: "center" }}>{displayItemQty(item)}</div>
                              </td>
                              <td>
                                <div style={{ marginTop: "2rem", textAlign: "right" }}>{getPrice(item, "subtotal")}</div>
                              </td>
                              <td>
                                <div style={{ marginTop: "2rem", textAlign: "right" }}>£{formatAsPrice(subTotal)}</div>
                              </td>
                            </tr>

                            {/* Mystery box nested products */}
                            {item.mystery_box_products && item.mystery_box_products.length > 0 && (
                              <tr>
                                <td colSpan={6} style={{ paddingLeft: "3rem", background: "#f9f9f9" , paddingTop : 5, paddingBottom :5}}>
                                  <div>
                                    <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between"}}> 
                                      <div><strong>Mystery Box Products :</strong></div>
                                      <button id={"item_" + item.id} style={{background :"transparent"}}>
                                        <span style={{fontWeight : 700, fontSize: 25}}> <i class="fa fa-angle-down" aria-hidden="true"></i></span> 
                                      </button>
                                    </div>
                                    <UncontrolledCollapse toggler={"#item_" + item.id}>
                                        <Table bordered size="sm" style={{ marginTop: "0.5rem" }}>
                                          <thead>
                                            <tr>
                                              <th style={{ width: "40%" }}>Product</th>
                                              <th style={{ width: "15%" }}>Color</th>
                                              <th style={{ width: "15%" }}>Size</th>
                                              <th style={{ width: "10%" }}>Qty</th>
                                              <th style={{ width: "10%" }}>Price</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {item.mystery_box_products.map((mbp) => (
                                              <tr key={mbp.id}>
                                                <td>
                                                  <div className="d-flex align-items-center">
                                                    <img width="40" className="img-fluid mr-2" src={mbp.image} />
                                                    <span>{mbp.sku}</span>
                                                  </div>
                                                </td>
                                                <td>{mbp.colour}</td>
                                                <td>{mbp.size}</td>
                                                <td>{mbp.qty}</td>
                                                <td>£{mbp.price}</td>
                                              </tr>
                                            ))}
                                          </tbody>
                                        </Table>
                                    </UncontrolledCollapse>
                                    
                                    
                                  </div>
                                </td>
                              </tr>
                            )}
                          </Fragment>

                        );
                      })
                    : null}
                </tbody>
              </Table>
            </div>

            <Row>
              <Col md={{ offset: 6, size: 6 }}>
                <table className="table">
                  <tbody>
                    <tr>
                      <td className="font-weight-bold">Sub Total:</td>
                      <td colSpan={2}>
                        {orderState.list.length} items (Total Quantity: {quantityTotal})
                      </td>
                      <td>
                        <div style={{ textAlign: "right" }}>£{formatAsPrice(orderSubTotal)}</div>
                      </td>
                    </tr>

                    {getDiscountItems().map((discount, discountIndex) => {
                      return (
                        <tr key={"discount_" + discountIndex}>
                          <td className="font-weight-bold">{discountIndex == 0 ? "Discount:" : ""}</td>
                          <td colSpan={2}>
                            {discount.title_1}
                            <br />
                            <strong>
                              <span className="small">({discount.title_2})</span>
                            </strong>
                          </td>
                          <td>
                            <div style={{ textAlign: "right" }}>-£{formatAsPrice(discount.discountAmount)}</div>
                          </td>
                        </tr>
                      );
                    })}

                    {userState.user.role.name !== "Seller" ? (
                      <tr>
                        <td className="font-weight-bold">Shipping:</td>
                        <td colSpan={2}></td>
                        <td>
                          <div style={{ textAlign: "right" }}>
                            £{orderState.data ? formatAsPrice(quantityTotal * orderState.data.per_item_shipping) : "0.00"}
                          </div>
                        </td>
                      </tr>
                    ) : (
                      ""
                    )}

                    <tr>
                      <td className="font-weight-bold">Tax:</td>
                      <td colSpan={2}>
                        {orderState.data && orderState.data.tax_rate > 0 ? "VAT (" + orderState.data.tax_rate * 100 + "%) (Included)" : ""}{" "}
                      </td>
                      <td>
                        <div style={{ textAlign: "right" }}>
                          £
                          {orderState.data
                            ? formatAsPrice(
                                vat +
                                  calculateShippingVAT(quantityTotal * orderState.data.per_item_shipping - shippingDiscount, orderState.data.tax_rate)
                              )
                            : "0.00"}
                        </div>
                      </td>
                    </tr>

                    {orderState.refunds.map((refund, refundIndex) => {
                      refundTotal += refund.total_refund_amount;

                      return (
                        <tr key={"refund_" + refundIndex}>
                          <td className="font-weight-bold">{refundIndex == 0 ? "Refund:" : ""}</td>
                          <td colSpan={2}>{refund.reason ? refund.reason : ""} </td>
                          <td>
                            <div style={{ textAlign: "right" }}>-£{formatAsPrice(refund.total_refund_amount)}</div>
                          </td>
                        </tr>
                      );
                    })}

                    <tr>
                      <td className="font-weight-bold">Total:</td>
                      <td colSpan={2}></td>
                      <td className="font-weight-bold">
                        <div style={{ textAlign: "right" }}>£{orderState.data ? getGrandTotal(quantityTotal, refundTotal) : ""}</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                {orderState.data && orderState.data.presentment_currency && orderState.data.presentment_currency !== "GBP" && Number(orderState.data.currency_rate) > 0 && (
                  <div className="text-right text-muted" style={{ fontSize: 12 }}>
                    Amounts are in GBP (shop currency). The customer paid{" "}
                    <strong>{currencyFormatter(orderState.data.presentment_currency).format(Number(orderState.data.total_price) * Number(orderState.data.currency_rate))}</strong>{" "}
                    ({orderState.data.presentment_currency}), converted by Shopify at 1 GBP = {Number(orderState.data.currency_rate)} {orderState.data.presentment_currency}.
                  </div>
                )}
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};
